import { createAction, props } from '@ngrx/store';

export enum GlobalActionTypes{
    Logout = '[Logout] Logout',
}

export const Logout = createAction(
    GlobalActionTypes.Logout
)